export const ToDoType = {
  ASSIGNED_TO_ME: "ASSIGNED_TO_ME",
  REQUESTED_BY_ME: "REQUESTED_BY_ME",
  ALL: "ALL"
};
